module.exports = __webpack_public_path__ + "img/driverDefault.2371f080.png";